import { render } from "./DeleteProjectModal.vue?vue&type=template&id=efe3cdd4&scoped=true"
import script from "./DeleteProjectModal.vue?vue&type=script&lang=js"
export * from "./DeleteProjectModal.vue?vue&type=script&lang=js"

import "./DeleteProjectModal.vue?vue&type=style&index=0&id=efe3cdd4&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe3cdd4"]])

export default __exports__